/*
 * @Author: 欲买桂花同载酒，终不似，少年游。
 * @Date: 2025-10-10 18:55:19
 * @LastEditors: 欲买桂花同载酒，终不似，少年游。
 * @LastEditTime: 2025-11-06 11:39:05
 * @FilePath: \fly-web\src\main.js
 * @filePurpose:
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// 可选：引入中文语言包
import zhCn from "element-plus/es/locale/lang/zh-cn";

import "@/assets/common.scss";
import "@/assets/mobile.scss";

import "./utils/setRem";

// import { createHead } from '@vueuse/head'
// const head = createHead()

createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, { locale: zhCn })
  // .use(head)
  .mount("#app");
